
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 0.5C4.98 0.5 0.5 4.98 0.5 10.5C0.5 16.02 4.98 20.5 10.5 20.5C16.02 20.5 20.5 16.02 20.5 10.5C20.5 4.98 16.02 0.5 10.5 0.5ZM7.79 14.79L4.2 11.2C3.81 10.81 3.81 10.18 4.2 9.79C4.59 9.4 5.22 9.4 5.61 9.79L8.5 12.67L15.38 5.79C15.77 5.4 16.4 5.4 16.79 5.79C17.18 6.18 17.18 6.81 16.79 7.2L9.2 14.79C8.82 15.18 8.18 15.18 7.79 14.79Z","fill":"#2957E7"}})])
          )
        }
      }
    